import { grey } from "@mui/material/colors";


declare module '@mui/material/styles' {
    interface Palette {
        greyScale: Palette['primary'];
        neutral: Palette['primary'];
    }
    interface PaletteOptions {
        greyScale?: PaletteOptions['primary'];
        neutral?: PaletteOptions['primary'];
    }
}
export const defaultPaletteDark = {
    mode: 'dark' as const,

    primary: {
        main: '#B480F2',
        light: '#E3CCFF',
        dark: '#793FBF',
        contrastText: '#fff',
    },
    secondary: {
        main: '#8F80F2',
        light: '#D3CCFF',
        dark: '#503FBF',
        contrastText: '#fff',
    },
    error: {
        main: '#F25064',
        light: '#FFB2BC',
        dark: '#BF192D',
        contrastText: '#fff',
    },
    success: {
        main: '#B8F274',
        light: '#E5FFC7',
        dark: '#80BF36',
        contrastText: '#fff',
    },
    warning: {
        main: '#F3CC61',
        light: '#FFEBB2',
        dark: '#BF9726',
        contrastText: '#1E1E1E',
    },
    greyScale: {
        main: grey[600],
        light: grey[900],
        dark: grey[300],
        contrastText: grey[800],
    },
    neutral: {
        main: '#808080',
        light: '#CCC',
        dark: '#595959',
        contrastText: '#FFF',
    },

    background: {
        default: '#121212',
    },


}